/** `aria-sort` value for a sortable column header. */
export function columnAriaSort(
  columnId: string,
  sortBy: string,
  sortOrder: 'asc' | 'desc',
): 'none' | 'ascending' | 'descending' {
  if (columnId !== sortBy) {
    return 'none';
  }
  return sortOrder === 'asc' ? 'ascending' : 'descending';
}

/** Accessible name for the notification bell, including unread count. */
export function notificationBellLabel(unreadCount: number): string {
  if (unreadCount <= 0) {
    return 'Benachrichtigungen';
  }
  return `Benachrichtigungen, ${unreadCount} ungelesen`;
}
